import {useCallback, useEffect, useRef} from 'react';

import {
  STPTwilio,
  TwilioClient,
} from '@stripe-internal/twilio-conversations-client';
import {TwilioConversationsOutboundPayload} from '@stripe-internal/stripethirdparty/lib/shared/TwilioConversationsTypes';
import {useInvisibleFrame} from '@stripe-internal/stripethirdparty';

import {App, AppConfig} from '../types';
import {useAppStateSelector} from '../hooks/appHooks';

function Initialized({
  config,
  chatClient,
}: {
  config: AppConfig;
  chatClient: TwilioClient;
}) {
  const twilioChatClientRef = useRef<TwilioClient | undefined>(chatClient);

  const handleSTPMessage = useCallback(
    (msg: TwilioConversationsOutboundPayload) => {
      twilioChatClientRef.current?.handleSTPEvent(msg);
    },
    [],
  );

  const invisibleFrame = useInvisibleFrame({
    baseURL: config.stripeThirdPartyBaseUrl,
    type: 'TwilioConversations',
    handleMessage: handleSTPMessage as unknown as (
      msg: TwilioConversationsOutboundPayload,
    ) => void | undefined,
  });

  useEffect(() => {
    if (invisibleFrame?.sendRequest) {
      chatClient.initialize(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        new STPTwilio(invisibleFrame.sendRequest),
      );
    }
  }, [chatClient, invisibleFrame]);

  return null;
}

export function STPTwilioIframe({
  app,
  chatClient,
}: {
  app: App;
  chatClient: TwilioClient;
}) {
  const useSelector = useAppStateSelector();
  const initialized = useSelector((state) => state.initialized);

  if (!initialized) {
    return null;
  }

  return <Initialized config={app.config} chatClient={chatClient} />;
}
